<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-account-hard-hat</v-icon> <span>{{$t('workers.crumb_add')}}</span>
      </h1>

      <div class="mt-16">
        <worker method="create"></worker>
      </div>
  </section>
</template>
<script>
import Worker from '@/components/workers/Worker'

export default {
  components: {
    Worker
  },
  beforeCreate(){
    document.title = "Report Lake - " + this.$t('workers.crumb_add');
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "workers.create"])) {
      this.$router.push('/admin');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/' + this.$session.get('domain')+ '/admin',
          exact: true,
        },
        {
          text: this.$t('menu.workers_management'),
          disabled: false,
          to: '/' + this.$session.get('domain')+ '/admin/workers-settings/workers',
          exact: true,
        },
        {
          text: this.$t('workers.crumb_add'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
